import { LanguageMessages } from '../components/Language';

import en from './en.json';

export const defaultLanguageMessages: LanguageMessages = en;
export const defaultLanguage: string = 'en';
